/* Crevel — PLP / search: AJAX filters, sort, load more, mobile filter drawer (no dependencies) */
(function(){
  if(window.__crvplp) return; window.__crvplp=1;
  var busy=false, timer=null;
  function root(){return document.querySelector('[data-crvplp]');}
  function wrapFor(r){return r && r.parentElement;}
  function buildUrl(form){
    var fd=new FormData(form), params=new URLSearchParams();
    fd.forEach(function(v,k){ if(v!=='' && v!=null) params.append(k,v); });
    var base=form.getAttribute('action')||location.pathname;
    var q=params.toString();
    return base+(q?'?'+q:'');
  }
  function withSection(url,id){return url+(url.indexOf('?')>-1?'&':'?')+'section_id='+encodeURIComponent(id);}
  function load(url,opts){
    var r=root(); if(!r||busy) return; busy=true;
    var id=r.dataset.section, wrap=wrapFor(r);
    r.classList.add('is-loading');
    fetch(withSection(url,id),{credentials:'same-origin'}).then(function(res){return res.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var fresh=doc.querySelector('[data-crvplp]');
      if(!fresh){location.href=url;return;}
      if(opts&&opts.append){
        var grid=r.querySelector('[data-crvplp-grid]'), fgrid=fresh.querySelector('[data-crvplp-grid]');
        if(grid&&fgrid){ while(fgrid.firstElementChild){grid.appendChild(fgrid.firstElementChild);} }
        var pages=r.querySelector('.crvplp__pages'), fpages=fresh.querySelector('.crvplp__pages');
        if(pages){ if(fpages){pages.replaceWith(fpages);} else {pages.remove();} }
      } else {
        var open=r.classList.contains('is-open');
        r.replaceWith(fresh);
        if(open){fresh.classList.add('is-open');}
        if(!(opts&&opts.keepScroll)){
          var top=fresh.getBoundingClientRect().top+window.pageYOffset-140;
          if(window.pageYOffset>top) window.scrollTo({top:top,behavior:'smooth'});
        }
      }
      if(!(opts&&opts.append)) history.replaceState({},'',url);
    }).catch(function(){location.href=url;}).finally(function(){busy=false;var rr=root();if(rr)rr.classList.remove('is-loading');});
  }
  document.addEventListener('change',function(e){
    var r=root(); if(!r||!r.contains(e.target)) return;
    if(e.target.matches('[data-crvplp-sort]')){
      var form=r.querySelector('[data-crvplp-form]');
      if(form){ form.querySelector('[data-crvplp-sortmirror]').value=e.target.value; load(buildUrl(form),{keepScroll:true}); }
      else { var u=new URL(location.href); u.searchParams.set('sort_by',e.target.value); load(u.pathname+u.search,{keepScroll:true}); }
      return;
    }
    var f=e.target.closest('[data-crvplp-form]');
    if(f && e.target.type==='checkbox'){ load(buildUrl(f),{keepScroll:true}); }
  });
  document.addEventListener('input',function(e){
    var r=root(); if(!r||!r.contains(e.target)) return;
    if(e.target.matches('[data-crvplp-find]')){
      var q=e.target.value.trim().toLowerCase(), list=e.target.nextElementSibling;
      if(list) list.querySelectorAll('li').forEach(function(li){li.style.display=!q||li.textContent.toLowerCase().indexOf(q)>-1?'':'none';});
      return;
    }
    if(e.target.type==='number'){
      var f=e.target.closest('[data-crvplp-form]'); clearTimeout(timer);
      timer=setTimeout(function(){load(buildUrl(f),{keepScroll:true});},700);
    }
  });
  document.addEventListener('submit',function(e){
    var f=e.target.closest('[data-crvplp-form]'); if(!f) return; e.preventDefault(); load(buildUrl(f),{keepScroll:true});
  });
  document.addEventListener('click',function(e){
    var r=root(); if(!r) return;
    var a=e.target.closest('[data-crvplp-link]');
    if(a&&r.contains(a)){ e.preventDefault(); load(a.getAttribute('href')); return; }
    var m=e.target.closest('[data-crvplp-more]');
    if(m&&r.contains(m)){ e.preventDefault(); m.disabled=true; m.classList.add('is-busy'); load(m.dataset.next,{append:true}); return; }
    if(e.target.closest('[data-crvplp-open]')){ r.classList.add('is-open'); document.documentElement.style.overflow='hidden'; return; }
    if(e.target.closest('[data-crvplp-close]')){ r.classList.remove('is-open'); document.documentElement.style.overflow=''; }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'){var r=root(); if(r&&r.classList.contains('is-open')){r.classList.remove('is-open');document.documentElement.style.overflow='';}} });
})();
